<span
  *ngFor="let criteria of groupCriteria; let i = index"
  class="group-criteria"
>
  {{
    columns[criteria.student_kpi_id]
      ? columns[criteria.student_kpi_id].title
      : ""
  }}<!--
  --><span *ngIf="columns[criteria.student_kpi_id]">: </span>
  <criteria-display-text
    *ngIf="columns[criteria.student_kpi_id]"
    [column]="columns[criteria.student_kpi_id]"
    [criteria]="criteria"
    [displaySymbols]="true"
    [colourText]="true"
  ></criteria-display-text
  ><!--
  --><span *ngIf="i < groupCriteria.length - 1" class="comma-span">,</span>
</span>
